import React, {
  useEffect,
  useState,
} from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import { fetchNotifications } from '../../../services/notificationService';

const NotificationDropdown = React.forwardRef((props, ref) => {
  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    const fetchedNotifications = fetchNotifications();
    setNotifications(fetchedNotifications);
  }, []);

  return (
    <div
      ref={ref}
      style={{
        border: "2px solid rgba(30, 58, 138, 0.1)",
        borderRadius: "12px",
        backgroundColor: "white",
        maxHeight: "300px",
        overflow: "auto",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        minWidth: "280px",
        marginTop: "8px",
        animation: "slideDown 0.2s ease-out",
      }}
    >
      <div style={{
        padding: "16px 20px",
        borderBottom: "1px solid rgba(30, 58, 138, 0.1)",
        backgroundColor: "rgba(30, 58, 138, 0.05)",
        color: "#1e3a8a",
        fontSize: "14px",
        fontWeight: "600",
        borderRadius: "10px 10px 0 0",
      }}>
        Notifications
      </div>
      <List style={{ padding: "8px 0" }}>
        {notifications.length > 0 ? (
          notifications.map((notification) => (
            <ListItem 
              key={notification.id} 
              button
              style={{
                padding: "12px 20px",
                transition: "all 0.2s ease",
              }}
              sx={{
                '&:hover': {
                  backgroundColor: "rgba(30, 58, 138, 0.05)",
                }
              }}
            >
              <ListItemText 
                primary={notification.message}
                style={{
                  color: "#1b130d",
                  fontSize: "14px",
                }}
              />
            </ListItem>
          ))
        ) : (
          <ListItem style={{ padding: "24px 20px", textAlign: "center" }}>
            <ListItemText 
              primary="No notifications"
              style={{
                color: "#9a6c4c",
                fontSize: "14px",
              }}
            />
          </ListItem>
        )}
      </List>
    </div>
  );
});

export default NotificationDropdown;
